import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { VersionPath } from 'app/core/common';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PathResources } from './models/path-resources';
import { MarketByOrigin } from './models/resources.interface';

@Injectable({
  providedIn: 'root'
})
export class ResourcesService {
  private readonly httpClient = inject(HttpClient);

  public marketsByOriginStation(originCode: string): Observable<MarketByOrigin[]> {
    const url = `${environment.btbBFF.bre.baseUrl}/${environment.btbBFF.bre.nameApi}/${VersionPath.Version1}/${PathResources.Markets}/${PathResources.ByOrigin}/${originCode}`;
    return this.httpClient.get<MarketByOrigin[]>(url);
  }
}
